import React from 'react'
import Footer from '../components/footer';
import Header from '../components/header';
import AboutComp from '../components/aboutcomp';

const About = () => {
  return (
    <>
      {<Header/>}
      {<AboutComp/>}
      {<Footer/>}
    </>
  )
}

export default About
